import DynamicSection from '../dynamic-section/dynamic-section';
import { ProductManager } from '@/js/product-utils';

class StickyAddToCart extends DynamicSection {
  connectedCallback() {
    this.initVariables();
    this.initManager();
    this.setupIntersectionObservers();
    this.addEventListeners();
  }

  initVariables() {
    this.scrollThreshold = 250;
    this.machineRadioBoxes = this.querySelectorAll('[data-machine-radio-box]');
    this.productMainWrapper = document.querySelector(
      '[data-product-main-wrapper]'
    );
  }

  /**
   * Initialize product manager for handling all product functionality
   * @returns {void}
   */
  initManager() {
    this.productManager = new ProductManager(this);
  }

  /**
   * Adds event listeners to machine radio boxes to handle option changes
   * Binds the onOptionChange handler to each radio box's change event
   * @returns {void}
   */
  addEventListeners() {
    for (const radioBox of this.machineRadioBoxes) {
      radioBox.addEventListener('change', this.onOptionChange.bind(this));
    }
  }

  /**
   * Sets up an IntersectionObserver to monitor visibility of the product CTA wrapper
   * and update the sticky add to cart visibility accordingly.
   * When the CTA wrapper is visible in viewport, hides the sticky add to cart.
   * When CTA wrapper is not visible, shows the sticky add to cart.
   * @returns {void}
   */
  setupIntersectionObservers() {
    const options = {
      threshold: 0
    };

    this.observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          delete this.dataset.visible;
        } else {
          this.dataset.visible = 'visible';
        }
      }
    }, options);

    this.observer.observe(this.productMainWrapper);
    delete this.dataset.loading;

    this.reSizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        const height = entry.target.clientHeight;
        document.documentElement.style.setProperty(
          '--sticky-footer-height',
          `${height}px`
        );
      }
    });

    this.reSizeObserver.observe(this);
  }

  /**
   * Handle updating the product form when an option value is selected
   * @returns {void}
   */
  onOptionChange() {
    // From the checked options, created a comma separated list of the selected option value IDs
    const checkedInputs = this.querySelectorAll(
      '[data-machine-radio-box]:checked'
    );
    const selectedOptionValues = [...checkedInputs]
      .map(input => input.value)
      .join(',');

    // Update the URL with the selected option value IDs
    const urlSearchParameters = new URLSearchParams(globalThis.location.search);
    urlSearchParameters.delete('variant');
    urlSearchParameters.set('option_values', selectedOptionValues);

    const productUrl = globalThis.location.pathname;
    const updatedUrl = `${productUrl}?${urlSearchParameters.toString()}`;

    this.reRenderSection({
      url: updatedUrl,
      replaceState: false,
      replaceEntireSection: true,
      afterReplaceMethod: () => {
        this.setupIntersectionObservers();
      }
    });
  }
}

customElements.get('sticky-add-to-cart') ||
  customElements.define('sticky-add-to-cart', StickyAddToCart);
